import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import qmsWorkflowActions from "../../../_actions/_qmsActions/qmsWorkflowActions";
import QmsAdminModal_EditWorkflow from "./QmsAdminModal_EditWorkflow";
import { QmsDataTable } from "../_common/QmsDataTable";

export default function QmsAdminCmtWorkflows(props) {
  const { divisionId, tabId } = props;

  const columns = [
    {
      id: "name",
      numeric: false,
      disablePadding: true,
      label: "Workflow Name",
    },
    {
      id: "description",
      numeric: false,
      disablePadding: false,
      label: "Description",
    },
    {
      id: "nodeCount",
      numeric: true,
      disablePadding: false,
      label: "Node Count",
    },
    {
      id: "createdOn",
      numeric: false,
      disablePadding: false,
      label: "Created On",
      render: (rowData) => new Date(rowData.createdOn).toLocaleDateString(),
    },
  ];

  const dispatch = useDispatch();
  const workflowList = useSelector((state) => state.qms.openWorkflowLists[tabId] || null);
  useEffect(() => dispatch(qmsWorkflowActions.getAll(divisionId, tabId)), []);

  return (
    <QmsDataTable
      data={workflowList}
      columns={columns}
      idName="workflowId"
      editModalComponent={
        <QmsAdminModal_EditWorkflow divisionId={divisionId} tabId={tabId} />
      }
      onDelete={(ids) => dispatch(qmsWorkflowActions.removeRange(ids, divisionId))}
      isExpandable={false}
    />
  );
}
